/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import styled from 'styled-components';
import * as R from 'ramda';
import {compose} from 'ramda';
/**
 * The internal dependencies.
 */
import NavigationIcons from '../../../assets/data/navigation-icons';
import {tasksDeselect, tasksRequest, tasksWorkFinished} from '../../../store/tasks/actions';
import {getTasksForCurrentUser} from '../../../store/tasks/selectors';
import {
    displayshop,
    getAuthUser,
    getDisplayDoneTab,
    isDispo,
    isOpmanager,
    isQuality
} from "../../../store/auth/selectors";
import {errorDeselect} from "../../../store/quality/actions";
import {ts_translate} from "../../../common/clientTranslate";

const NavigationWrapper = styled.ul`
	display: flex;
`;

const NavItem = styled(Link)`
	display: flex;
	align-items: center;
	color: ${({active}) => active ? '#42affa' : '#686871'};
	text-decoration: none;
	background: ${({active}) => active ? '#686871' : '#f8f8f8'};
	padding: 10px 13px 14px;
	border:none;
	outline: none;


	&:hover,
	&:focus,
	&:active {
		opacity: .8;
	}
`;

const NavItemEmpty = styled.div`
	display: flex;
	align-items: center;
	color: ${({active}) => active ? '#42affa' : '#686871'};
	text-decoration: none;
	background: ${({active}) => active ? '#686871' : '#f8f8f8'};
	padding: 10px 13px 14px;
	border:none;
	outline: none;
    cursor: pointer;

	&:hover,
	&:focus,
	&:active {
		opacity: .8;
	}
`;

const NavIcon = styled.i`
	position: relative;
	display: inline-block;
	width: 18px;
	height: 18px;
	margin-right: ${({iconOnly}) => iconOnly ? 0 : '7px'};
	background: url(${({data}) => data});
	background-size: contain;
	background-repeat: no-repeat;

	${({count}) => count > 0
    ? `
			&:before {
				content: '${count}';
				position: absolute;
				top: -7px;
				right: -7px;
				display: block;
				width: 14px;
				height: 14px;
				text-align: center;
				font-size: 8px;
				line-height: 8px;
				font-weight: 700;
				font-style: normal;
				color: #fff;
				background: #42affa;
				padding: 4px 0;
				border-radius: 50%;
			}
		`
    : ''
}
`;

class Navigation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentLocation: this.props.location.pathname,
        }
    }

    componentDidUpdate(oldProps) {
        if (oldProps.location.pathname === this.props.location.pathname && this.state.currentLocation) {
            return;
        }

        this.setState({currentLocation: this.props.location.pathname});
    }

    clickhandler(path) {
        const {
            tasksDeselect,
            errorDeselect,
            tasksWorkFinished
        } = this.props;
        const {currentLocation} = this.state;
        // console.debug("currentLocation:", currentLocation);
        tasksDeselect();
        errorDeselect();
        tasksWorkFinished();
        this.setState({currentLocation: path});
    }

    render() {
        const {currentLocation} = this.state;
        const {
            tasksForUser,
            tasksDeselect,
            isQuality,
            errorDeselect,
            tasksRequest,
            isDispo,
            displayshop,
            isOpmanager,
            displayDoneTab,
        } = this.props;

        let routes = []

        const isReserved = (task) => task.status === 'reserved';
        const isWorking = (task) => task.status === 'in-progress';
        const isFailed = (task) => task.status === 'failed';

        if (displayshop && !isOpmanager) {
            routes.push(
                {
                    to: 'shop',
                    label: 'Shop',
                    quantity: R.length(tasksForUser),
                });
        }
        if (!isOpmanager) {
            routes.push(
                {
                    to: 'stock',
                    label: 'Vorrat',
                    quantity: R.length(R.filter(isReserved, tasksForUser)),
                });
            routes.push(
                {
                    to: 'working',
                    label: 'In Arbeit',
                    quantity: R.length(R.filter(isWorking, tasksForUser)),
                });
        }
        if (isQuality) {
            routes.push({
                to: 'quality',
                label: 'Qualitäter',
                // quantity: R.length(tasksForUser),
            });
        }

        if (isDispo) {
            routes.push({
                to: 'disponent',
                label: ts_translate('Disponent'),
                quantity: R.length(tasksForUser),
            });
        }
        if (displayDoneTab) {
            routes.push(
                {
                    to: 'done',
                    label: 'Erledigt',
                    quantity: 0,
                });
        }
        return (
            <NavigationWrapper>
                <NavItem to="/" active={1}>
                    <NavIcon data={NavigationIcons.home} iconOnly/>
                </NavItem>

                <NavItemEmpty to="/" onClick={() => {
                    tasksRequest();
                }} active={1}>
                    <NavIcon data={NavigationIcons.reload} iconOnly/>
                </NavItemEmpty>

                {routes && routes.map(route => {
                    const isActive = currentLocation.match(route.to);
                    const path = `/dashboard/${route.to}`;

                    return (
                        <NavItem
                            key={`dashboard-nav-${route.to}`}
                            to={path}
                            active={isActive}
                            onClick={() => {
                                this.clickhandler(path);
                            }}
                        >
                            <NavIcon
                                data={NavigationIcons[route.to][isActive ? 'active' : 'inactive']}
                                count={route.quantity}
                            />

                            <span>{route.label}</span>
                        </NavItem>
                    )
                })}
            </NavigationWrapper>
        );
    }
}

export default compose(
    connect(state => ({
        tasksForUser: getTasksForCurrentUser(state),
        user: getAuthUser(state),
        isQuality: isQuality(state),
        isDispo: isDispo(state),
        displayshop: displayshop(state),
        isOpmanager: isOpmanager(state),
        displayDoneTab: getDisplayDoneTab(state),
    }), {
        tasksDeselect,
        errorDeselect,
        tasksWorkFinished,
        tasksRequest
    }),
    withRouter
)(Navigation);



// WEBPACK FOOTER //
// ./src/components/dashboard/header/navigation.js